/*create by ma.rongqin 2017.1.10*/
'use strict';
angular.module('trsReplaceSpecharModule', [])
    .filter("trsReplaceDoubleQuotes", function($sce) {
        return function(input) {
            if (angular.isDefined(input)) {
                input = input.replace(/"/g, '&quot;');
            }
            return input;
        };
    });
